/**
 * @generated SignedSource<<7d9e03769d2a1db5b6758dcb5c2e5e3f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SignalDetailScreenRegisterAsSeenEmployeeMutation$variables = {
  employeeId?: string | null;
  signalWorkspaceId: string;
};
export type SignalDetailScreenRegisterAsSeenEmployeeMutation$data = {
  readonly signal: {
    readonly registerEmployeeReceiverReceipt: {
      readonly employeeReceiverReceipts: ReadonlyArray<{
        readonly employeeId: string | null;
        readonly openedAtDate: {
          readonly " $fragmentSpreads": FragmentRefs<"FormattedDate">;
        };
        readonly signalWorkspaceId: string;
      }>;
      readonly employeeReceiverReceiptsCount: number;
      readonly id: string;
      readonly opened: boolean;
    };
  };
};
export type SignalDetailScreenRegisterAsSeenEmployeeMutation = {
  response: SignalDetailScreenRegisterAsSeenEmployeeMutation$data;
  variables: SignalDetailScreenRegisterAsSeenEmployeeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "employeeId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "signalWorkspaceId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "signalWorkspaceId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "employeeId",
    "variableName": "employeeId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "opened",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "employeeReceiverReceiptsCount",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "signalWorkspaceId",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "employeeId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SignalDetailScreenRegisterAsSeenEmployeeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "SignalMutation",
        "kind": "LinkedField",
        "name": "signal",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "Signal",
            "kind": "LinkedField",
            "name": "registerEmployeeReceiverReceipt",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SignalEmployeeReceiverReceipt",
                "kind": "LinkedField",
                "name": "employeeReceiverReceipts",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnzonedDate",
                    "kind": "LinkedField",
                    "name": "openedAtDate",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "FormattedDate"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "SignalDetailScreenRegisterAsSeenEmployeeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "SignalMutation",
        "kind": "LinkedField",
        "name": "signal",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "Signal",
            "kind": "LinkedField",
            "name": "registerEmployeeReceiverReceipt",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SignalEmployeeReceiverReceipt",
                "kind": "LinkedField",
                "name": "employeeReceiverReceipts",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnzonedDate",
                    "kind": "LinkedField",
                    "name": "openedAtDate",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isoString",
                            "storageKey": null
                          }
                        ],
                        "type": "Date",
                        "abstractKey": "__isDate"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5d8b82f3f93c6723b31b03b6b5c1706c",
    "id": null,
    "metadata": {},
    "name": "SignalDetailScreenRegisterAsSeenEmployeeMutation",
    "operationKind": "mutation",
    "text": "mutation SignalDetailScreenRegisterAsSeenEmployeeMutation(\n  $signalWorkspaceId: ID!\n  $employeeId: ID\n) {\n  signal(id: $signalWorkspaceId) {\n    registerEmployeeReceiverReceipt(employeeId: $employeeId) {\n      id\n      opened\n      employeeReceiverReceiptsCount\n      employeeReceiverReceipts {\n        signalWorkspaceId\n        employeeId\n        openedAtDate {\n          ...FormattedDate\n        }\n      }\n    }\n  }\n}\n\nfragment FormattedDate on Date {\n  __isDate: __typename\n  ...useFormattedDate\n}\n\nfragment useFormattedDate on Date {\n  __isDate: __typename\n  isoString\n}\n"
  }
};
})();

(node as any).hash = "844892d95cb0b194ee694717916ae52d";

export default node;
